import { render, staticRenderFns } from "./select-collection.vue?vue&type=template&id=ed4ffafc&scoped=true&"
import script from "./select-collection.vue?vue&type=script&lang=js&"
export * from "./select-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4ffafc",
  null
  
)

export default component.exports